export default "<ion-header [translucent]=\"true\">\r\n</ion-header>\r\n\r\n<ion-content>\r\n</ion-content>\r\n\r\n<ion-footer>\r\n</ion-footer>\r\n";